import module from 'cliente/module.js'
import template from './template.html'

export class ClienteInformacionBancosEliminarComponent {
  idCliente
  idCuenta
  data
  eliminar = false
  onChange

  cerrar (data) {
    if (data) {
      this.onChange()
    }
    this.eliminar = false
  }
}

module.component('clienteInformacionBancosEliminar', {
  controller: ClienteInformacionBancosEliminarComponent,
  template,
  bindings: {
    idCliente: '<',
    idCuenta: '<',
    data: '<',
    onChange: '&',
  },
})



// WEBPACK FOOTER //
// ./src/cliente/components/informacion/bancos/eliminar/component.js